import React from 'react';
import type { ChatMessage } from './ChatBot';
import { trackWidgetEvent } from '../utils/analytics';
import { CHAT_TRANSCRIPT_DOWNLOAD_SHOWN } from '@/lib/analytics-events';
import { canShowTranscriptDownload } from './generateTranscript';

export function useTranscriptDownloadShown(
  transcriptDownloadEnabled: boolean,
  history: ChatMessage[],
  chatOpen = true,
): boolean {
  const visible = canShowTranscriptDownload(transcriptDownloadEnabled);
  const hasTrackedShownRef = React.useRef(false);
  const prevChatOpenRef = React.useRef(chatOpen);

  React.useEffect(() => {
    if (prevChatOpenRef.current && !chatOpen) {
      hasTrackedShownRef.current = false;
    }
    prevChatOpenRef.current = chatOpen;
  }, [chatOpen]);

  React.useEffect(() => {
    if (!visible || !chatOpen || hasTrackedShownRef.current) return;

    const completedCount = history.filter((msg) => Boolean(msg.text?.trim())).length;
    trackWidgetEvent(CHAT_TRANSCRIPT_DOWNLOAD_SHOWN, {
      channel: 'web',
      message_count: completedCount,
      is_identified_lead: false,
    });
    hasTrackedShownRef.current = true;
  }, [visible, chatOpen, history]);

  return visible;
}
